enum AiAssistUsageSorting {
  ByName = 'ByName',
  ByUsageCount = 'ByUsageCount',
  ByDate = 'ByDate',
  ByClientType = 'ByClientType',
}

export default AiAssistUsageSorting;
